(() => {
  const policyLinkSelector = '#shopify-pc__banner__body-policy-link';
  const localPolicyUrl = `${window.location.origin}/policies/privacy-policy`;

  const localizePolicyLink = () => {
    const policyLink = document.querySelector(policyLinkSelector);

    if (!policyLink) return false;

    if (policyLink.href !== localPolicyUrl) {
      policyLink.href = localPolicyUrl;
    }

    return true;
  };

  if (localizePolicyLink()) return;

  const observer = new MutationObserver(() => {
    if (localizePolicyLink()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
